import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';
import offlineRfsRemote from '../../../api/offlineRfsRemote';

import WhsOrdersList from './WhsOrdersList';
import WhsOfflineOrdersList from './WhsOfflineOrdersList';

import ResponseError from '../../../models/ResponseError';
import ApiResponse from '../../../models/ApiResponse';
import OrderWhs from '../../../models/OrderWhs';
import OfflineOrderWhs from '../../../models/OfflineOrderWhs';

import moment, { Moment } from 'moment';
import AwbListDialog from './AwbListDialog';
import OrderWhsDetails from '../../../models/OrderWhsDetails';

interface WhsOrdersListContainerProps {
  receiveError: Function;
  type: string;
  setCounts: Function;
  orderLockedNumber: string;
};
  
interface WhsOrdersListContainerState {
  pickupOrders: OrderWhs[],
  dropOffOrders:  OrderWhs[],
  goOrders: OrderWhs[],
  rfsOrders: OfflineOrderWhs[],
  orderDate: Moment;
  dropOffOrder: OrderWhsDetails;
  openDialog: boolean;
};

class WhsOrdersListContainer extends Component<WhsOrdersListContainerProps, WhsOrdersListContainerState> {

  state = {
    pickupOrders: [],
    dropOffOrders: [],
    goOrders: [],
    rfsOrders: [],
    orderDate: moment(),
    dropOffOrder: {} as OrderWhsDetails,
    openDialog: false
  }
  
  async componentDidMount() {
    
    const date: string = this.state.orderDate.format('YYYYMMDD');

    if (this.props.orderLockedNumber) {

      await pickupOrderRemote.doGhaWhPoLock(this.props.orderLockedNumber, false);
    }

    this.loadOrders('po', date);
    this.loadOrders('do', date);
    this.loadOrders('go', date);
    this.loadOfflineOrders(date);
  }

  loadOrders = (type: string, date: string ): void => {

    pickupOrderRemote.getPickupOrdersWhs(type, date).then((resp: ApiResponse<Array<OrderWhs>>) => {

      const orders: Array<OrderWhs> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (orders) {
        if (type === 'po') {
          this.setState({ pickupOrders: orders});
        }
        if (type === 'do') {
          this.setState({ dropOffOrders: orders});
        }
        if (type === 'go') {
          this.setState({ goOrders: orders});
        }
        this.props.setCounts(type, orders.length);
      }
      
      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  loadOfflineOrders = (date: string): void => {

    offlineRfsRemote.getOfflineOrdersWhs(date).then((resp: ApiResponse<Array<OfflineOrderWhs>>) => {

      const offlineOrders: Array<OfflineOrderWhs> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (offlineOrders) {
        this.setState({ rfsOrders: offlineOrders});
        this.props.setCounts('rfs', offlineOrders.length);
      }
      
      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  changeDate = (date: Moment): void => {

    const currentDateStr: Moment = this.state.orderDate;

    if (currentDateStr !== date) {

      this.setState({ orderDate: date });
      const newDate: string = date.format('YYYYMMDD');
      this.loadOrders('po', newDate);
      this.loadOrders('do', newDate);
      this.loadOrders('go', newDate);
      this.loadOfflineOrders(newDate)
    }
  };

  onMouseEnter = (number: string): void => {
    console.log("hover over");
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const start = params.get('start');
    this.setState({ openDialog: true }, () => {
      pickupOrderRemote.getPickupOrderWhs(number, '', Boolean(start)).then((resp: ApiResponse<OrderWhsDetails>) => {

        const dropOffOrder: OrderWhsDetails | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (dropOffOrder) {
          
          this.setState({ dropOffOrder });
  
        }
  
        if (error) {
          this.props.receiveError(error);
        };
      });
    })
  
  }

  onMouseLeave = (): void => {
    this.setState({ openDialog: false })
  }

  render() {

    const orderList = this.props.type === 'po' ? this.state.pickupOrders : this.props.type === 'do' ? this.state.dropOffOrders : this.state.goOrders;

    return (
      <>
      {(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') ?
        <WhsOrdersList 
          orders={ orderList } 
          orderDate={ this.state.orderDate }
          dateChange={ this.changeDate }
          type={this.props.type}
          hover={ this.onMouseEnter }
        />
        : null }
        { this.state.openDialog &&
          <AwbListDialog
            dropOffOrder={this.state.dropOffOrder}
            closeDialog={ this.onMouseLeave }
          />
        }
        {this.props.type === 'rfs' && (
          <WhsOfflineOrdersList 
            orders={ this.state.rfsOrders } 
            orderDate={ this.state.orderDate }
            dateChange={ this.changeDate }
            type={ this.props.type }
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    orderLockedNumber: state.orderLockedNumber
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(WhsOrdersListContainer);